// Angular
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// External
import { AngularFireAuth } from "angularfire2/auth";
import * as firebase from "firebase/app";

@Injectable()
export class OAuthService {
  private user: firebase.User;
  private club: any;

  constructor(private router: Router, private fireAuth: AngularFireAuth, private route:ActivatedRoute) {
    this.fireAuth.authState.subscribe((user) => {
      this.user = user;
      if (!user && Object.keys(this.route.snapshot.queryParams).length== 0 ) {
        this.router.navigate(["/login"]);
      }
    });
  }

  getUser() {
    return this.user;
  }

  setClub(club: any) {
    // if(club.subscription)
    //     club.subscription = new Date(club.subscription);

    this.club = club;
    console.log(club);

    return localStorage.setItem("club", JSON.stringify(club));
  }

  getClub() {
    return JSON.parse(localStorage.getItem("club"));
  }

  logout() {
    this.club = null;
    localStorage.clear();
    return this.fireAuth.auth.signOut();
  }
}
